import { __toESM } from "./chunk-B4qE4VCv.mjs";
import { require_Option } from "./Option-D1XhUpjC.mjs";

//#region src/overloadMaybe.ts
var import_Option = /* @__PURE__ */ __toESM(require_Option());
/**
* For converting from Monet's `Maybe` to an fp-ts `Option`.
*
* Returns a value that can be used as either an `Option` or a `Maybe`.
*
* @deprecated Switch to `fp-ts` directly or use `convertMonet` functions.
* @private
* @example
* ```ts twoslash
* import { overloadMaybe } from '@simplisafe/ewok'
* import * as O from 'fp-ts/lib/Option.js'
* import { pipe } from 'fp-ts/lib/function.js'
* import { Just } from 'monet'
*
* overloadMaybe(Just(42)).map(n => n + 1) // => Just(43)
*
* pipe(overloadMaybe(Just(42)), O.map(n => n + 1)) // => O.Some(43)
* ```
*/
function overloadMaybe(m) {
	const x = m.cata(() => import_Option.none, import_Option.of);
	return Object.assign(m, x);
}
var overloadMaybe_default = overloadMaybe;

//#endregion
export { overloadMaybe_default };